import { render, staticRenderFns } from "./HistorySection.vue?vue&type=template&id=22950818&scoped=true&"
import script from "./HistorySection.vue?vue&type=script&lang=js&"
export * from "./HistorySection.vue?vue&type=script&lang=js&"
import style0 from "./HistorySection.vue?vue&type=style&index=0&id=22950818&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22950818",
  null
  
)

export default component.exports